import { useState } from "react";
import useBlockViewportScroll from "app/pages/.shared/useBlockViewportScroll";
import { useAnalytics } from "app/utils/analytics/useAnalytics";

/**
 * Open state of the membership signup dialog. Opening it is tracked, and the page
 * behind stops scrolling while it is open.
 */
export const useSignupDialog = () => {
	const [isOpen, setIsOpen] = useState(false);
	const { track } = useAnalytics();

	useBlockViewportScroll(isOpen);

	const open = () => {
		track("membership_signup_click");
		setIsOpen(true);
	};

	const close = () => {
		setIsOpen(false);
	};

	return { isOpen, open, close };
};
